import FeKeyInterceptor from "./keyInterceptor";

/**
 * Interface representing an HTML element with a FeKeyInterceptor.
 */
export default interface FeKeyInterceptorHTMLElement extends HTMLElement
{
  feKeyInterceptor: FeKeyInterceptor;
}

/**
 * Factory class for managing FeKeyInterceptor instances.
 */
export default class FeKeyInterceptorFactory
{
  private _logger: any;

  /**
   * Creates an instance of FeKeyInterceptorFactory.
   * @param options - Configuration options for the FeKeyInterceptorFactory.
   */
  constructor (options)
  {
    this._logger = options.enableLogging ? console.log : (message) => { };
    this._logger('[Nucor.Iron.UI.Js | FeKeyInterceptorFactory] Factory initialized', { options });
  }

  /**
   * Connects a FeKeyInterceptor to an HTML element.
   * @param dotNetRef - Reference to the .NET object.
   * @param elementId - The ID of the HTML element to connect to.
   * @param options - Configuration options for the FeKeyInterceptor.
   * @throws Will throw an error if no element ID is provided or if no element is found for the given ID.
   */
  connect (dotNetRef, elementId, options)
  {
    this._logger('[Nucor.Iron.UI.Js | FeKeyInterceptorFactory] connect ', { dotNetRef, elementId, options });
    if (!elementId)
      throw "No element ID was provided.  This is required.";

    const element = document.getElementById(elementId) as FeKeyInterceptorHTMLElement;
    if (!element)
      throw "No element found for id: " + elementId;

    if (!element.feKeyInterceptor)
      element.feKeyInterceptor = new FeKeyInterceptor(dotNetRef, options);

    element.feKeyInterceptor.connect(element);
  }

  /**
   * Updates the key configuration of a FeKeyInterceptor.
   * @param elementId - The ID of the HTML element whose FeKeyInterceptor should be updated.
   * @param options - New configuration options for the FeKeyInterceptor.
   */
  updateKey (elementId, options) 
  {
    const element = document.getElementById(elementId) as FeKeyInterceptorHTMLElement;
    if (!element || !element.feKeyInterceptor)
      return;

    element.feKeyInterceptor.updateKey(options);
  }

  /**
   * Disconnects a FeKeyInterceptor from an HTML element.
   * @param elementId - The ID of the HTML element to disconnect from.
   * @returns void
   */
  disconnect (elementId)
  {
    const element = document.getElementById(elementId) as FeKeyInterceptorHTMLElement;
    if (!element || !element.feKeyInterceptor)
      return;

    element.feKeyInterceptor.disconnect();
  }
}